module.exports = __webpack_public_path__ + "img/ChinaAMC.68a98405.png";